import React from 'react';
import './NavBar.css'
import { NavLink, withRouter } from 'react-router-dom';
import authClient from '../auth/Auth';
import { API } from './../constants/constants';
import Axios from 'axios';

import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

//Snackbars
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const useStyles = makeStyles(theme => ({
    authToken: {
        textAlign: "left",
        width: 400,
        fontSize: 8,
        color: "rgba(255,255,255,1)"
    },
    typography: {
        textAlign: "left",
        color: "rgba(255,255,255,1)"
    },
    paper: {
        padding: '10px 10px 10px 10px',
        background: 'rgba(105,105,105,1)'
    }
}));

function NavBar(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [isStaging, setStaging] = React.useState(false);

    const isActive = (path, match, location) => {
        return match && match.isExact;
    }
    function onUserClick() {
        setOpen(true);
    }

    function handleClose() {
        setOpen(false);
    }

    function signOut() {
        handleClose();
        authClient.signOut();
    }

    function wipeOut() {
        handleClose();
        Axios.delete(isStaging ? API.staging.deleteStaging : API.production.deleteStaging, {
            headers: { 'x-access-token': authClient.getIdToken() }
        })
            .then(response => {
                console.log(response.data);
                alert(`Staging environment cleared: ${response.data.data.successful}`);
            })
            .catch(function (error) {
                console.log(error);
                alert("Error deleting staging environment");
            })
            .then(function () {
                // always executed
                console.log("call finished");
            });
    }

    const switchLabel = (isStaging) => {
        return isStaging ? "Staging Environment" : "Production environment";
    }

    const handleSwitchChange = (event) => {
        setStaging(event.target.checked);
        if (props.callback) {
            props.callback(event.target.checked);
        }
    }

    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-primary fixed-top">
            <Typography>Airfind Notifications</Typography>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarColor01" aria-controls="navbarColor01" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>

            {
                authClient.getProfile() ?
                    <div className="collapse navbar-collapse" id="navbarColor01">

                        <ul className="navbar-nav mr-auto">
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/" isActive={isActive.bind(this, '/')} activeClassName="active">Home</NavLink>

                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/stats" isActive={isActive.bind(this, '/stats')} activeClassName="active"> Notification stats</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/userBase" isActive={isActive.bind(this, '/userBase')} activeClassName="active"> User Base</NavLink>
                            </li>
                        </ul>
                        <div className="form-inline my-2 my-lg-0">
                            <FormControlLabel control={<Switch value="prod" onChange={handleSwitchChange} />} label={switchLabel(isStaging)} />
                            <div className="btn btn-secondary" onClick={onUserClick}>
                                <span><img className="NavBar-avatar" alt="" src={authClient.getProfile().photoURL} /></span>
                                {authClient.getProfile().displayName}
                            </div>
                        </div>
                        <Snackbar
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={open}
                            autoHideDuration={5000}
                            onClose={handleClose} >
                            <SnackbarContent
                                aria-describedby="client-snackbar"
                                message={
                                    <Paper className={classes.paper}>
                                        <Typography className={classes.typography}>AuthToken: </Typography>
                                        <code>
                                            <Typography component="p" className={classes.authToken}>
                                                {authClient.getIdToken()}
                                            </Typography>
                                        </code>
                                        <Button variant="contained" color="primary" onClick={wipeOut}>
                                            Wipe out staging data
                                        </Button>
                                        <Button variant="contained" color="primary" onClick={signOut}>
                                            Sign Out
                                        </Button>
                                    </Paper>
                                }
                            />
                        </Snackbar>
                    </div>
                    : null
            }
        </nav>
    );
}
export default withRouter(NavBar);